
const state = {
  test1: null,
  themeBar: false,
  uploading: false,
  progressmsg: 'File uploaded: ',
  percentageUploaded: 0,
  resetSplitButtonLocation: 0,
  errorsMessages: [],
  reLoginDialog: false,
  lastPage: '',
  lastFromPage: '',
  lastPathName: '',
  // Name of the record currently open in a detail page, published by the
  // *TabsDetails components so the breadcrumb can show it instead of a raw id.
  breadcrumbRecord: '',
  // What kind of record that is, when the page names it itself ("Task" for a task opened
  // at /activities/:id); '' leaves the crumb on the route's own label ("Activity").
  breadcrumbRecordType: '',
  // The drill-down path the user has actually taken, as
  // [{ key, label, fullPath }] - see AppBreadcrumb.syncTrail. Held here rather
  // than in the component so it survives the component being torn down and
  // rebuilt on every navigation.
  breadcrumbTrail: [],
  lastEPs: [],
  staticMenuDesktopInactive: null,
  activeThemeColor: 'blue', // stored as hex codes
  appWindowWidth: null,
  appWindowHeight: null,
  videosData: [],
  requestingVideos: false,
  lastErrorEP: null,
  epError: null,
  epPayload: null,
  errorCode: null,
  epDatetime: null
}

export default state